export default "__VITE_ASSET__1cSKShkk__"